import Reports from 'components/CampaignReports';
import React from 'react';
const CampaignReports = () => {
  return <Reports />;
};
export default CampaignReports;
